import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { setCurrentUser } from '../../ducks/user.duck';

export const saveShippingAddressThunk = createAsyncThunk(
  'ShippingAddressForm/saveShippingAddress',
  (address, { dispatch, extra: sdk, rejectWithValue }) => {
    return sdk.currentUser
      .updateProfile(
        {
          protectedData: {
            shippingAddress: address,
          },
        },
        { expand: true }
      )
      .then(response => {
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        dispatch(setCurrentUser(entities[0]));
        return response;
      })
      .catch(e => {
        log.error(e, 'save-shipping-address-failed', { address });
        return rejectWithValue(storableError(e));
      });
  }
);

export const saveShippingAddress = address => dispatch => {
  return dispatch(saveShippingAddressThunk(address)).unwrap();
};

const shippingAddressFormSlice = createSlice({
  name: 'ShippingAddressForm',
  initialState: {
    saveInProgress: false,
    saveError: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(saveShippingAddressThunk.pending, state => {
        state.saveInProgress = true;
        state.saveError = null;
      })
      .addCase(saveShippingAddressThunk.fulfilled, state => {
        state.saveInProgress = false;
      })
      .addCase(saveShippingAddressThunk.rejected, (state, action) => {
        state.saveInProgress = false;
        state.saveError = action.payload;
      });
  },
});

export default shippingAddressFormSlice.reducer;
